import Dashboard from "../pages/dashboard/Dashboard";
import Franchisor from "../pages/register/franchisor/Franchisor";
import Invester from "../pages/register/invester/Invester";
import ChannelPartnerRegistration from "../pages/register/channelpartnerregistration/ChannelPartnerRegistration";
import Automotive from "../pages/sidebarcomponent/automotive/Automotive";
import Automotivedetails from "../pages/sidebarcomponent/automotive/Automotivedetails";
import BuySell from "../pages/sidebarcomponent/buysell/BuySell";
import Advertise from "../pages/sidebarcomponent/advertise/Advertise";
import RaiseFund from "../pages/sidebarcomponent/raisefund/RaiseFund";
import BussinessLoan from "../pages/sidebarcomponent/bussinessloan/BussinessLoan";
import Blog from "../pages/blogs/Blog";
import BlogDeatils from "../pages/blogs/BlogDeatils";
import About from "../pages/about/About";
import Testimonials from "../pages/testimonials/Testimonials";
import Contact from "../pages/contact/Contact";
import SaleOpportunity from "../pages/SaleOpprtunity/SaleOpportunity.jsx";
import Video from "../pages/videos/Video.jsx";
import Faqs from "../pages/faqs/Faqs.jsx";
import TermsAndCondition from "../pages/T&C/TermsAndCondition.jsx";
import Startupdetails from "../pages/startup/Startupdetails.js";

export const routes = [
  { path: "/", element: <Dashboard />, wrapper: false },
  { path: "/franchiser", element: <Franchisor />, wrapper: true },
  { path: "/Investor", element: <Invester />, wrapper: true },
  {
    path: "/channelpartnerregistration",
    element: <ChannelPartnerRegistration />,
    wrapper: true,
  },
  { path: "/products/:productId", element: <Automotive />, wrapper: true },
  {
    path: "/franchise-opportunity/:productId",
    element: <Automotivedetails />,
    wrapper: true,
  },
  {
    path: "/startupdetails",
    element: <Startupdetails />,
    wrapper: true,
  },
  { path: "/buysell", element: <BuySell />, wrapper: true },
  { path: "/advertise", element: <Advertise />, wrapper: true },
  { path: "/raisefund", element: <RaiseFund />, wrapper: true },
  { path: "/loan-bussiness", element: <BussinessLoan />, wrapper: true },
  { path: "/blogs", element: <Blog />, wrapper: true },
  { path: "/blogdetails", element: <BlogDeatils />, wrapper: true },
  { path: "/about", element: <About />, wrapper: true },
  { path: "/contact", element: <Contact />, wrapper: true },
  { path: "/testimonial", element: <Testimonials />, wrapper: true },
  { path: "/saledetails", element: <SaleOpportunity />, wrapper: true },
  { path: "/video", element: <Video />, wrapper: true },
  { path: "/faq", element: <Faqs />, wrapper: true },
  { path: "/terms", element: <TermsAndCondition />, wrapper: true },
];

